module.exports = __webpack_public_path__ + "static/media/productos_botanas_garbanzo_enchilado.4f532a9e.png";